export default {
    customers: [],
    customersLoading: false,
    customersTypes: [],
    customerContacts: [],
    customerAddresses : [],
    addressTypes: [],
    countries: [],
    productionFileCustomerConfiguration: [],
    customerAddressesLoading: false,
    customerContactsLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        name: null,
        customer: '',
    }
}